import clsx from 'clsx';
import * as React from 'react';

export type PaperProps = React.ComponentPropsWithoutRef<'div'>;

export const Paper = React.forwardRef(function Paper(
    props: PaperProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <div
            ref={ref}
            {...props}
            className={clsx(
                'rounded-md border border-control bg-base shadow-elevated',
                props.className
            )}
        />
    );
});
